export class KeyEventAction {
    constructor(key, callback) {
        this.callback = callback;
        this.key = key;
        this.doKeyAction = this.doKeyAction.bind(this);
        this.init();
    }

    init() {
        window.addEventListener('keydown', this.doKeyAction);
    }

    removeKeyAction(){
        window.removeEventListener('keydown', this.doKeyAction)
    }

    doKeyAction(e) {
        if(e.key === this.key) {
            this.callback()
        }
    }
}